const CLEARTRIP_BYPASS_ORIGIN = process.env.NEXT_PUBLIC_CLEARTRIP_ORIGIN || 'https://ui2.cltpstatic.com'

export const getCleartripScriptOrigin = () => {
    return CLEARTRIP_BYPASS_ORIGIN
}

